import Vue from 'vue'
import Meta from 'vue-meta'
import * as VueGoogleMaps from 'vue2-google-maps'
import PortalVue from 'portal-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import filters from './util/view-filters'
import { route } from './util/helpers'
import gmapsConfig from './config/maps'

/**
 * Register global plugins (non-Vue related)
 */
import './plugins'

/**
 * Register Vue filters
 */
Object.entries(filters).forEach(([name, func]) => {
  Vue.filter(name, func)
})

/**
 * Configure Google Maps
 */

Vue.use(VueGoogleMaps, {
  load: {
    key: gmapsConfig.apiKey
  },
  installComponents: false
})

Vue.use(PortalVue)

Vue.use(Meta)

Vue.mixin({
  methods: {
    route(...args) {
      return route(...args)
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
